import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem, Divider } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { EnumOperadora, IComboOperadora } from '@model/Operadora';
import { IContaFilter } from '@services/ContaService';
import React from 'react';

export type ContaFilterProps = {
    filter: IFilter<IContaFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    numerosContrato: string[]
}

export function ContaFilter ({filter, isLoading, empresaCombo, numerosContrato}: ContaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        <Divider />
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Operadora"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumOperadora.None}>Todas</MenuItem>
                        <Divider />
                        {
                            numerosContrato.map(v => {
                                return <MenuItem key={v}>v</MenuItem>
                            })
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}